import { gql } from '@apollo/client';

export const CLAIMED_DAILY_COIN_DROP_CHECK = gql`
  query ClaimedDailyCoinDrop {
    claimedDailyCoinDrop
  }
`;
